import React, {useState, useEffect, useContext} from 'react';
import localization from 'assets/localization/localization';
import Images from 'assets/images/imageData';
import Layout from 'components/sales/layout/layout';
import {Button} from 'react-bootstrap';
import {Link, useParams} from 'react-router-dom';
import ModalPop from 'components/sales/modal/modal';
import {BaseUrl} from 'contexts/baseUrl/baseUrl';
import {toast} from "react-toastify";
import HelperForm from "../HelperForm/HelperForm";

const AddHelper = ({
                       match,
                       addHelper,
                       history,
                       listing,
                       list = [],
                       byId,
                       byIdDetails = [],
                       addDetails = []
                   }) => {

    const {baseUrl} = useContext(BaseUrl);
    const [isFiled, setIsFiled] = useState(false);
    const pocInputs = {
        pocDetails: null,
    };
    const [isModal, setIsModal] = useState(false);
    const [pocData, setCorporateData] = useState(pocInputs);
    const [isLoading, setIsLoading] = useState(false);
    const [msg, setMsg] = useState('');

    useEffect(() => {
        if (match?.params?.helper_id !== undefined) {
            (async () => {
                await byId(match?.params?.helper_id);
            })();
        }
    }, [match?.params?.helper_id]);

    useEffect(() => {
        (async () => {
            await listing(match?.params?.lead_id);
        })();
    }, []);

    const handleSubmit = async () => {
        const {pocDetails} = pocData;

        if (pocDetails === null) {
            setIsFiled(true);
            setIsModal(false);
            return false;
        } else {
            if (handleValidation(pocDetails?.phone_no, pocDetails?.email)) {
                return false
            }

            if (handleDuplicateEmailOrPhoneNo(pocDetails?.phone_no, pocDetails?.email)) {
                return false
            }

            setIsFiled(false);
            if (match?.params?.helper_id !== undefined) {
                if (pocDetails.name !== '') {
                    setIsLoading(true);
                    const res = await addHelper(pocDetails);
                    setIsLoading(false);
                    setIsModal(true);
                    setMsg(localization.helperSuccess)
                    if (parseInt(res?.status) !== 200) {
                        setMsg(localization.helperFailed)
                    }
                }
            } else {
                if (pocDetails.name !== '') {
                    setIsLoading(true);
                    const res = await addHelper(pocDetails);
                    setIsLoading(false);
                    setIsModal(true);
                    setMsg(localization.helperSuccess)
                    if (parseInt(res?.status) !== 200) {
                        setMsg(localization.helperFailed)
                    }
                }
            }
        }
    };

    const handleValidation = (phoneNo, emailId) => {
        let phoneRegex = /^(\+91-|\+91|0)?\d{10}$/
        if (!phoneRegex.test(phoneNo)) {
            toast.error("Please enter correct phone number")
            return true
        }

        let emailRegex = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        if (!emailRegex.test(emailId)) {
            toast.error("Please enter a correct email.")
            return true
        }

        return false
    }

    const handleDuplicateEmailOrPhoneNo = (no, email) => {
        let isTrue = false
        let msg = ''
        if (list?.data !== undefined && list?.data !== [] && list?.data.length > 0) {
            // eslint-disable-next-line array-callback-return
            list?.data.map((val, i) => {
                if (match?.params?.helper_id !== undefined) {
                    if (byIdDetails?.phone_no !== undefined && byIdDetails?.phone_no !== parseInt(no) && parseInt(val?.phone_no) === parseInt(no)) {
                        msg = no + " already exist."
                        isTrue = true
                    }

                    if (byIdDetails?.email !== undefined && byIdDetails?.email !== email && val?.email === email) {
                        msg = email + " already exist."
                        isTrue = true
                    }

                } else {
                    if (parseInt(val?.phone_no) === parseInt(no)) {
                        msg = no + " already exist."
                        isTrue = true
                    }

                    if (val?.email === email) {
                        msg = email + " already exist."
                        isTrue = true
                    }
                }
            })
            if (isTrue) {
                toast.error(msg)
                return isTrue
            }
        }

        return false
    }

    const handleModalHide = () => {
        setIsModal(false);
    };

    const headerBtns = () => {
        return (
            <Button onClick={handleSubmit} className="btn btn-primary">
                {localization.submitDtl}
                <img src={Images?.ArrowRight} alt=""/>
            </Button>
        );
    };
    const handlePocSubmit = (val) => {
        setCorporateData({...pocData, pocDetails: val});
    };

    return (
        <Layout
            title={match?.params?.helper_id !== undefined ? localization.ediHelper : localization.addHelper}
            Buttons={headerBtns}
            className={isFiled ? 'requiredFileds' : ''}
            isGoback
            isLoading={isLoading}
            linkUrl={`${baseUrl}/brand-activation/helper-list/${match.params.lead_id}/${match.params.id}`}
        >
            <HelperForm
                pocById={byIdDetails}
                handleValue={handlePocSubmit}
                id={match?.params?.helper_id !== undefined ? match?.params?.helper_id : null}
                leadId={match.params.lead_id}
            />
            <ModalPop
                title={localization.conf}
                show={isModal}
                handleModalHide={handleModalHide}
            >
                <div className="text-center">
                    <div className="success">
                        <img src={Images?.tick} alt=""/>
                    </div>
                    <h5>{msg}</h5>
                    {addDetails?.data !== undefined && parseInt(addDetails?.status) === 200 &&
                        <Link
                            to={`${baseUrl}/brand-activation/helper-list/${match.params.lead_id}/${match.params.id}`}
                            className="btn btn-primary mb-4"
                        >
                            {localization.HelperList} <img src={Images?.ArrowRight} alt=""/>
                        </Link>
                    }
                </div>
            </ModalPop>
        </Layout>
    );
};

AddHelper.propTypes = {};

export default AddHelper;
